import axios from "axios";

export default async function getRedirectUrls(headers) {
  try {
    const response = await axios({
      method: "get",
      url: `https://onboardstaging.backendprod.com/api/org/whatsapp/onboard`,
      headers: headers,
    });

    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(error);
  }
}
